(ns manatee.admin.pending-items.subs
  "App. DB subscriptions for the Admin. Pending Items tab."
  (:require
   [manatee.admin.pending-items.app-db :as db]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::pending-items
 (fn [db _]
   (db/get-pending-items db)))

(rf/reg-sub
 ::pending-items-to-reassign
 (fn [db _]
   (db/get-pending-items-to-reassign db)))

(rf/reg-sub
 ::assign-to
 (fn [db _]
   (db/get-user-to-assign-to db)))
